export default "__VITE_ASSET__DQVHXueg__"